<div [@fade]="animationState" (@fade.done)="onAnimationEnd($event)">
  <ng-template cdkPortalOutlet></ng-template>
</div>
